import React, { useEffect, useState } from "react";
import Layout, { PageHeader, Surface, StatusPill } from "@/components/Layout";
import { api } from "@/lib/api";

export default function Webhooks() {
  const [merchants, setMerchants] = useState([]);
  useEffect(() => { api.get("/admin/merchants").then((r) => setMerchants(r.data.items)); }, []);

  return (
    <Layout>
      <div className="p-4 sm:p-6 lg:p-10" data-testid="webhooks-page">
        <PageHeader title="Webhooks" subtitle="Webhook URL configuration per merchant. Use the Proxy API to test deliveries." />

        <Surface>
          <div className="table-scroll">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] uppercase tracking-[0.05em] font-semibold text-zinc-500 border-b border-zinc-100">
                <th className="px-5 py-3">Merchant</th>
                <th className="px-5 py-3">Webhook URL</th>
                <th className="px-5 py-3">Status</th>
                <th className="px-5 py-3">Updated</th>
              </tr>
            </thead>
            <tbody>
              {merchants.map((m) => (
                <tr key={m.id} className="border-b border-zinc-50">
                  <td className="px-5 py-3 font-medium">{m.company_name}</td>
                  <td className="px-5 py-3 font-mono text-xs text-zinc-600">{m.webhook_url || <span className="text-zinc-400">not configured</span>}</td>
                  <td className="px-5 py-3"><StatusPill value={m.webhook_url ? "active" : "pending"} /></td>
                  <td className="px-5 py-3 text-xs text-zinc-500">{(m.updated_at || "").slice(0, 16).replace("T", " ")}</td>
                </tr>
              ))}
              {merchants.length === 0 && <tr><td colSpan={4} className="px-5 py-10 text-center text-xs text-zinc-500">No merchants.</td></tr>}
            </tbody>
          </table>
        </div>
        </Surface>

        <Surface className="p-5 mt-4">
          <div className="font-display text-lg tracking-tight font-medium mb-2">Outgoing event format</div>
          <pre className="bg-zinc-950 text-emerald-200 font-mono text-[11px] p-4 rounded-sm overflow-x-auto">
{`POST {webhook_url}
X-Blonix-Signature: t=<unix_ts>,v1=<hmac_sha256>
Content-Type: application/json

{
  "id": "evt_...",
  "event": "card.created",
  "merchant_id": "...",
  "data": { "card_id": "...", "masked_pan": "**** **** **** 1234" },
  "timestamp": "2026-02-...Z"
}`}
          </pre>
        </Surface>
      </div>
    </Layout>
  );
}
